import React from 'react'
import { truncate } from 'utils/common'

const ActionRenderer = ({ color, onClick, column, truncateLength, notFoundText }) => {

  if(!column?.name) {
    return <button
      className={`viso-text-label`}>
        {notFoundText}
      </button>
  }

  return (
    <button
      className={`viso-text-${color}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick(column)
      }}>
      {column?.name && <span title={column.name}>{truncate(column.name, truncateLength)}</span>}
    </button>
  )
}

export default ActionRenderer